import { usePermissions } from '@/shared/permissions';

import { PROMO_PERMISSIONS } from '../model/permissions';

export interface PromoPermissions {
  /** Browse campaigns/promotions/coupons/product sets/audit/simulator. */
  canView: boolean;
  /** Author/edit campaigns, promotions, coupons, product sets, settings. */
  canManage: boolean;
  /** Approve/reject a PENDING_APPROVAL promotion — deliberately distinct from `canManage`. */
  canApprove: boolean;
  /** Create/edit/delete budgets (no separate view tier — budget reads also require this). */
  canManageBudgets: boolean;
}

/** Resolves the four promo permission flags from the session permissions. */
export function usePromoPermissions(): PromoPermissions {
  const { hasPermission } = usePermissions();
  return {
    canView: hasPermission(PROMO_PERMISSIONS.promo.view),
    canManage: hasPermission(PROMO_PERMISSIONS.promo.manage),
    canApprove: hasPermission(PROMO_PERMISSIONS.promo.approve),
    canManageBudgets: hasPermission(PROMO_PERMISSIONS.budgets.manage),
  };
}
